require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-shopify-unite-2018-multi-currency-announced-for-shopify-plus-merchants.json") })
        }
      }, "path---blog-shopify-unite-2018-multi-currency-announced-for-shopify-plus-merchants");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-shopify-unite-2018-multi-currency-announced-for-shopify-plus-merchants!./.cache/json/blog-shopify-unite-2018-multi-currency-announced-for-shopify-plus-merchants.json
// module id = 494
// module chunks = 231608221292675